module.exports = __webpack_public_path__ + "img/member-panel.8469c3ea.png";